<div>
  <span>{{messagePartA}}</span>
  <a class="id37-link" (click)="goToProfile()">{{report}}</a>
  <span>{{messagePartB}}</span>
</div>
